<template>
  <div>
    <div ref="triggerRef1">
      <div ref="pinRef" class="pin">
        <div class="box-detail" :class="{ active }">
          <div class="box-detail__instruction" ref="instructionRef">
            <div>
              <img src="../../../assets/icons/arrow_up.png" alt="arrow-down" />
              <!-- @load="onLoadStart" -->
              <div class="instructions">{{ text.instructions }}</div>
            </div>
          </div>
          <button class="cautionButton"  @click="submit()">{{ $t("CautionPage.CAUTION") }}</button>
            <Caution  v-if="buttonclicked" :onOk="onUnderstand" />
          <div class="box-detail__prepare" ref="prepareRef">
            <h2 class="title">{{ text.prepare }}</h2>
            <div class="img">
              <img :src="prepareImgSrc" />
            </div>
          </div>
          <div class="box-detail__design" ref="desingRef">
            <h2 class="order-number mt-0">01</h2>
            <h2 class="title">{{ text.design1 }}</h2>
            <h3 class="description secondary-text-color">
              {{ text.design2 }}
            </h3>
            <div class="design-slider">
              <div class="slider-image" @scroll="onScroll" ref="slide">
                <img :src="designSliderImage" />
              </div>
              <div class="indicator-list">
                <div @click="onClickIndicator(0)" class="indicator-wrapper">
                  <div
                    class="indicator"
                    :class="{
                      active: indicatorIndex === 0,
                    }"
                  ></div>
                </div>
                <div @click="onClickIndicator(1)" class="indicator-wrapper">
                  <div
                    class="indicator"
                    :class="{
                      active: indicatorIndex === 1,
                    }"
                  ></div>
                </div>
              </div>
              <ul class="design-warning">
                <li>
                  <span class="design-warning-dot"></span>
                  {{ text.designWarning1 }}
                </li>
                <li>
                  <span class="design-warning-dot"></span>
                  {{ text.designWarning2 }}
                </li>
              </ul>
              <h3 class="design-warning3">
                {{ text.designWarning3 }}
              </h3>
              <h3 class="design-dot-image">
                <img
                  srcset="
                    ../../../assets/dot-image.png     720w,
                    ../../../assets/dot-image-pc.png 1024w
                  "
                  src="../../../assets/dot-image-pc.png"
                  alt="Space Between Dot Image Description"
                />
              </h3>
              <div class="just-center">
                <div class="design-image-list">
                  <div
                    class="design-image-item"
                    v-for="(item, i) in designImageList"
                    :key="i"
                  >
                    <div class="design-image-item__title">
                      <span
                        v-if="item.numberText"
                        class="design-image-item__title_text margin-right"
                      >
                        {{ item.numberText }}
                      </span>
                      <img
                        class="design-image-number"
                        :src="numberList[item.number]"
                        :alt="item.number"
                      />
                      <span class="design-image-item__title_text margin-left">
                        {{ item.text }}&nbsp;
                        <!-- vue can not support empty text in code (ex ' ' or nbsp)-->
                        {{
                          item.side ? $t(`DetailGuidePage.${item.side}`) : "ﾠﾠ"
                        }}&nbsp;
                        {{ item.sideNumber }}
                        {{ item.side2 && $t(`DetailGuidePage.${item.side2}`) }}
                        {{ item.sideNumber2 }}
                      </span>
                    </div>
                    <div class="design-image-item__image">
                      <img :src="item.image" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="box-detail__assemble-title">
            <h2 class="order-number">02</h2>
            <h2 class="box-detail__assemble__primary">
              {{ text.cutAndAssemble1 }}
            </h2>
            <h2 class="box-detail__assemble__secondary secondary-text-color">
              {{ text.cutAndAssemble2 }}
            </h2>
          </div>
          <div class="box-detail__assemble-wrapper">
            <div class="box-detail__assemble cutout" ref="assembleRef">
              <h2 class="box-detail__assemble__cut-out-parts">
                {{ text.cutAndAssemble3 }}
              </h2>
              <div>
                <img
                  class="cutout-img"
                  :src="cutOutPartsImage"
                  alt="Cut Out Parts"
                />
              </div>
            </div>
            <!-- cutoutpart2 -->
            <div
              v-if="cutOutPartsImage2"
              class="box-detail__assemble fold"
              ref="assembleFoldRef"
            >
              <h2 class="box-detail__assemble__cut-out-parts opacity">
                {{ text.cutAndAssemble3 }}
              </h2>
              <div>
                <img
                  class="cutout-img-fold"
                  :src="cutOutPartsImage2"
                  alt="Cut Out Parts"
                />
              </div>
            </div>
            <!-- cutoutpart3 -->
            <div
              v-if="cutOutPartsImage3"
              class="box-detail__assemble fold"
              ref="assembleFoldRef"
            >
              <h2 class="box-detail__assemble__cut-out-parts opacity">
                {{ text.cutAndAssemble3 }}
              </h2>
              <div>
                <img
                  class="cutout-img-fold"
                  :src="cutOutPartsImage3"
                  alt="Cut Out Parts"
                />
              </div>
            </div>
            <!-- foldpart -->
            <div
              v-if="cutOutPartsFoldImage"
              class="box-detail__assemble fold"
              ref="assembleFoldRef"
            >
              <h2 class="box-detail__assemble__cut-out-parts margin-0">
                {{ text.fold1 }}
              </h2>
              <h2
                class="box-detail__assemble__fold-secondary secondary-text-color"
              >
                {{ text.fold2 }}
              </h2>
              <div>
                <img
                  class="cutout-img-fold"
                  :src="cutOutPartsFoldImage"
                  alt="Cut Out Parts Fold"
                />
              </div>
            </div>
             <!-- foldpart2 -->
            <div
              v-if="cutOutPartsFoldImage2"
              class="box-detail__assemble fold"
              ref="assembleFoldRef"
            >
              <h2 class="box-detail__assemble__cut-out-parts margin-0">
                {{ text.fold1 }}
              </h2>
              <h2
                class="box-detail__assemble__fold-secondary secondary-text-color"
              >
                {{ text.fold3 }}
              </h2>
              <div>
                <img
                  class="cutout-img-fold"
                  :src="cutOutPartsFoldImage2"
                  alt="Cut Out Parts Fold"
                />
              </div>
            </div>
            <!-- glueoutpart -->
            <div
              v-if="gluePartsImage"
              class="box-detail__assemble fold"
              ref="assembleFoldRef"
            >
              <h2 class="box-detail__assemble__cut-out-parts margin-0">
                {{ text.fold1 }}
              </h2>
              <h2
                class="box-detail__assemble__fold-secondary secondary-text-color"
              >
                {{ text.glue }}
              </h2>
              <div>
                <img
                  class="cutout-img-fold"
                  :src="gluePartsImage"
                  alt="Cut Out Parts glue"
                />
              </div>
            </div>
            <!-- cablepart -->
            <div
              v-if="cablePartsImage"
              class="box-detail__assemble fold"
              ref="assembleFoldRef"
            >
              <h2 class="box-detail__assemble__cut-out-parts margin-0">
                {{ text.fold1 }}
              </h2>
              <h2
                class="box-detail__assemble__fold-secondary secondary-text-color"
              >
                {{ text.cable }}
              </h2>
              <div>
                <img
                  class="cutout-img-fold"
                  :src="cablePartsImage"
                  alt="Cut Out Parts cable"
                />
              </div>
            </div>
            <div
              class=".box-detail__assemble box-detail__assemble-sequence"
              ref="assembleSequenceRef"
            >
              <h2 class="sequence_title">
                {{ text.cutAndAssemble4 }}
              </h2>
              <div class="sequence-image">
                <img :src="assembleImgSrc" ref="assembleImageRef" />
              </div>
            </div>
          </div>
          <div class="box-detail__complete" ref="completeRef">
            <h2 class="order-number">03</h2>
            <h2 class="primary-title">{{ text.complete }}</h2>
            <img
              class="completeImage"
              :srcset="`${completeImage} 720w, ${completeImagePc} 1000w`"
              :src="completeImage"
            />
            <div class="txt-center">
              <router-link
                class="route-button left"
                :to="`/categories/${categoryKey}`"
                >{{ text.backButton }}</router-link
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as ScrollMagic from "scrollmagic";
import { TweenMax, Linear } from "gsap";
import OnLoadImage from "@/components/mixin/OnLoadImage";
import "imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators";
import Caution from "../Caution";

export default {
  mixins: [OnLoadImage],
  components:{
     Caution,
  },
  props: {
    text: {
      type: Object,
    },
    prepareSequenceImages: {
      type: Array,
      default: () => [],
    },
    designSliderImage: {
      type: String,
    },
    designImageList: {
      type: Array,
      default: () => [],
    },
    cutOutPartsImage: {
      type: String,
    },
    cutOutPartsImage2: {
      type: String,
      default: () => null,
    },
    cutOutPartsImage3: {
      type: String,
      default: () => null,
    },
    assembleSequenceImages: {
      type: Array,
      default: () => [],
    },
    cutOutPartsFoldImage: {
      type: String,
      default: () => null,
    },
    cutOutPartsFoldImage2: {
      type: String,
      default: () => null,
    },
    gluePartsImage: {
      type: String,
      default: () => null,
    },
    cablePartsImage: {
      type: String,
      default: () => null,
    },
    completeImage: {
      type: String,
    },
    completeImagePc: {
      type: String,
    },
    categoryKey: {
      type: String,
    },
    
  },
  watch: {
    "$route.params"() {
      window.scrollTo(0, 0);
      location.reload();
    },
  },
  data() {
    return {
      prepareImgSrc: "",
      assembleImgSrc: "",
      indicatorIndex: 0,
      sequenceHeight: 0,
      durationTime: 6500,
      active: false,
      showFoldImage: false,
      checkLang:"",
      numberList: {
        1: require("../../../assets/icons/01.png"),
        2: require("../../../assets/icons/02.png"),
        3: require("../../../assets/icons/03.png"),
        4: require("../../../assets/icons/04.png"),
        5: require("../../../assets/icons/05.png"),
        6: require("../../../assets/icons/06.png"),
        7: require("../../../assets/icons/07.png"),
        8: require("../../../assets/icons/08.png"),
        9: require("../../../assets/icons/09.png"),
        10: require("../../../assets/icons/10.png"),
        11: require("../../../assets/icons/11.png"),
        12: require("../../../assets/icons/12.png"),
        13: require("../../../assets/icons/13.png"),
        14: require("../../../assets/icons/14.png"),
        15: require("../../../assets/icons/15.png"),
        16: require("../../../assets/icons/16.png"),
        17: require("../../../assets/icons/17.png"),
        18: require("../../../assets/icons/18.png"),
        19: require("../../../assets/icons/19.png"),
        20: require("../../../assets/icons/20.png"),
        21: require("../../../assets/icons/21.png"),
        22: require("../../../assets/icons/22.png"),
        23: require("../../../assets/icons/23.png"),
      },
      buttonclicked:false,
    };
  },
  async created() {
    
    window.scrollTo(0, 0);
    // if there is no cutOutPartsFoldImage /img/(number or cC)
    // so check if src first letter
    // if it is number or C showFoldIamge = false
    // const regExp = /^[c0-9]+$/;
    // const IsNotFoldImage = regExp.test(
    //   this.cutOutPartsFoldImage.replace("/img/", "").substr(0, 1)
    // );
    // if (!IsNotFoldImage) {
    //   // do stuff with the string
    //   this.showFoldImage = true;
    // }
    await this.load();
    await new Promise((res) => setTimeout(res, 500));
    this.onImageLoadComplete();
 
  },

  methods: {
    submit(){
      this.buttonclicked=true;
      console.log("clicked!")
       },
    onUnderstand() {
      // this.cautionViewed = true;
      // console.log(this.cautionViewed)
       this.buttonclicked=false;
      console.log("clicked!")
    },

    setDelay() {
      const length = this.assembleSequenceImages.length;
      switch (true) {
        case length < 50:
          return (this.durationTime = 4500);
        case length < 70:
          return (this.durationTime = 7000);
        case length < 100:
          return (this.durationTime = 10000);
        case length < 130:
          return (this.durationTime = 11500);
        case length < 160:
          return (this.durationTime = 13000);
        default:
          return (this.durationTime = 3000);
      }
    },
    async load() {
      this.setDelay();
      this.assembleImgSrc = this.assembleSequenceImages[0];
      this.prepareImgSrc = this.prepareSequenceImages[0];
      await this.loadImages([
        ...this.assembleSequenceImages,
        ...this.prepareSequenceImages,
        this.designSliderImage,
        ...this.designImageList.map((v) => v.image),
        this.cutOutPartsImage,
        require("../../../assets/dot-image-pc.png"),
      ]);

      this.active = true;
    },
    onImageLoadComplete() {
      this.$nextTick(() => {
        const pinRef = this.$refs.pinRef;
        // const instructionRef = this.$refs.instructionRef;
        // const prepareRef = this.$refs.prepareRef;
        // const assembleRef = this.$refs.assembleRef;
        const assembleSequenceRef = this.$refs.assembleSequenceRef;
        // const completeRef = this.$refs.completeRef;
        const height = window.innerHeight;
        const controller = new ScrollMagic.Controller();
        const parentTop = pinRef.getBoundingClientRect().top; // Initial parent's top distance from the top of the viewport;
        // const prepareTop = prepareRef.getBoundingClientRect().top;
        // const firstOffset = prepareTop - height / 5;

        {
          const tween = this.createImageSequenceTween(
            this.prepareSequenceImages,
            "prepareImgSrc"
          );

          new ScrollMagic.Scene({
            triggerElement: this.$refs.triggerRef1,
            triggerHook: 0,
            duration: 2000,
            offset: 0,
          })
            // .addIndicators({ name: "1" })
            .setPin(pinRef, { pushFollwers: false })
            .setTween(tween)
            .addTo(controller);
        }
        {
          // const prepareTop = prepareRef.getBoundingClientRect().top - parentTop;
          const sequenceTop =
            assembleSequenceRef.getBoundingClientRect().top - parentTop;
          const tween = this.createImageSequenceTween(
            this.assembleSequenceImages,
            "assembleImgSrc"
          );
          new ScrollMagic.Scene({
            triggerElement: this.$refs.triggerRef1,
            triggerHook: 0,
            duration: this.durationTime,
            offset:
              2000 +
              sequenceTop -
              height / 2 +
              // 2 / height +
              this.$refs.assembleSequenceRef.getBoundingClientRect().height / 2,
          })
            // height / 2
            .setPin(pinRef, { pushFollwers: false })
            .setTween(tween)
            .addTo(controller);

          this.active = true;
        }
      });
    },
    createImageSequenceTween(images, changeProperty) {
      const obj = { curImg: 0 };
      return TweenMax.to(obj, 1, {
        curImg: images.length - 1, // animate propery curImg to number of images
        roundProps: "curImg", // only integers so it can be used as an array index
        repeat: 0, // repeat 3 times
        immediateRender: true, // load first image automatically
        ease: Linear.easeNone, // show every image the same ammount of time
        onUpdate: () => {
          this[changeProperty] = images[obj.curImg]; // set the image source
        },
      });
    },
    onScroll(e) {
      const scrollLeft = e.target.scrollLeft;
      const scrollRight =
        e.target.scrollWidth - e.target.clientWidth - e.target.scrollLeft;
      if (-10 <= scrollLeft && scrollLeft <= 10) {
        this.indicatorIndex = 0;
      } else if (-10 <= scrollRight && scrollRight <= 10) {
        this.indicatorIndex = 1;
      }
    },
    onClickIndicator(index) {
      const slideRef = this.$refs.slide;
      if (index === 0) {
        slideRef.scrollTo({ left: 0, behavior: "smooth" });
      } else {
        slideRef.scrollTo({ left: 1000, behavior: "smooth" });
      }
    },
  },
   
};
</script>

<style scoped>
.instructions{
  padding-bottom:25px;
}
.cautionButton{
 margin-top:20px;
 padding-left:0;
 float:left;
 background-color:#111111;
 border:none;
 color: #9f9f9f;
 cursor:pointer;
 text-decoration: underline;
 font-size:0.83rem;
 font-family: 'SamsungSharpSans';
 font-weight: 500;
}

.box-detail {
  /* min-height: 500%; */
  background-color: #111111;
  border-radius: 30px;
  width: 100% !important;
  margin: auto;
  box-sizing: border-box;
  /* display: flex;
  flex-direction: column;
  justify-content: center; */

  /* height: 2000px; */
  /* display: flex; */
  /* flex-direction: column; */
  /* justify-content: space-between; */
  opacity: 0;
}
.box-detail.active {
  opacity: 1;
}

.box-detail > * {
  padding-left: 20px;
  padding-right: 20px;
  opacity: 0;
  transition: all 0.5s ease-out;
}
.box-detail.active > * {
  transition: all 0.5s ease-out;
  opacity: 1;
}
.box-detail__instruction {
  text-align: center;
  padding-top: 1px;
}
.box-detail__instruction div {
  text-align: center;
  /* padding-top: 20px; */
}
.box-detail__instruction > div > * {
  text-align: center;
  /* text-align: center; */
  margin: auto;
  display: block;
  margin-top: 15px;
  font-size: 0.83rem;
}
.box-detail__prepare .title {
  margin-top: 45px;
  margin-bottom: 0;
}
.box-detail__prepare img {
  width: 100%;
  max-width: 100%;
  margin-top: 10px;
  max-height: 100vh;
  object-fit: contain;
}
.order-number {
  margin-top: 90px;
  font-size: 2.5rem;
  margin-bottom: 0;
}
.box-detail__design .title {
  font-size: 1.83rem;
  margin-bottom: 0;
  margin-top: 0;
}
.box-detail__design .description {
  margin-top: 10px;
  margin-bottom: 0;
}
/* .design-slider {
  overflow-x: auto;
} */
.design-warning {
  margin-top: 25px;
}

.design-warning li {
  /* position: relative; */
  font-size: 1.33rem;
  margin-top: 5px;
  font-weight: 700;
}
.design-warning-dot {
  display: inline-block;
  width: 10px;
  height: 5px;

  position: relative;
}
.design-warning-dot::after {
  display: inline-block;
  position: absolute;
  content: " * ";
  /* background-color: #f5f5f5; */
  /* border-radius: 50%; */
  transform: translateY(-40%);
  /* top: 10%;
  position: relative; */
}

.design-dot-image {
  margin-top: 20px;
}
.design-dot-image img {
  width: 257px;
}

.slider-image {
  overflow-x: auto;
  width: 100vw;
  margin-left: -20px;
  padding: 0 20px;
  box-sizing: border-box;
  margin-top: 12px;
}
.slider-image img {
  width: calc(200% + 40px);
  /* max-width: 200%; */
  object-fit: contain;
}
.slider-image::-webkit-scrollbar {
  height: 0 !important;
  background-color: rgba(0, 0, 0, 0);
}
.design-warning3 {
  font-size: 1.33rem;
  margin-top: 50px;
}
.cutout-img,
.cutout-img-fold {
  width: 100%;
  max-width: 100vw;
  object-fit: contain;
}
/* .design-image-list {
  margin-top: 40px;
} */
.design-image-list {
  display: grid;
  grid-template-rows: auto;
  grid-template-columns: repeat(1, 1fr);
  grid-row-gap: 30px;
  grid-column-gap: 30px;
  /* margin-top: 40px; */
}
.design-image-list .design-image-item .design-image-item__title {
  position: relative;
  display: flex;
  align-items: center;
  /* padding-left: 22px; */
}
.opacity {
  opacity: 0;
}
.design-image-item__title_text.margin-right {
  margin-right: 2px;
}
.design-image-item__title_text.margin-left {
  margin-left: 2px;
}
.design-image-list
  .design-image-item
  .design-image-item__title
  .design-image-number {
  display: inline-block;
  width: 19px;
  /* vertical-align: middle; */
  /* position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%); */
}
.mt-0 {
  margin-top: 0px !important;
}



@media (min-width: 540px) and (max-width: 719px) {
  .design-image-list {
    grid-template-rows: auto;
    grid-template-columns: repeat(2, 1fr);
  }
}

.design-image-item {
  margin-top: 60px;
  width: 100%;
}
.design-image-item .design-image-item__title {
  font-size: 1.83rem;
  font-weight: 700;
  font-family: "SamsungOne";
}

.design-image-item .design-image-item__image {
  /* font-size: 1.83rem;
  font-weight: 700; */
  margin-top: 18px;
}
.design-image-item .design-image-item__image img {
  /* font-size: 1.83rem;
  font-weight: 700; */
  width: 100%;
}

.box-detail__assemble__primary {
  margin-top: 0;
  margin-bottom: 10px;
  font-size: 1.83rem;
}
.box-detail__assemble__secondary {
  margin-top: 10px;
  font-size: 1.33rem;
  max-width: 70vw;
  /* margin-bottom: 10px; */
}
.box-detail__assemble__fold-secondary {
  margin-top: 16px;
  font-size: 1.33rem;
  max-width: 70vw;
  /* margin-bottom: 10px; */
}
.box-detail__assemble__cut-out-parts {
  margin-top: 60px;
  margin-bottom: 0;
  font-size: 1.83rem;
}
.box-detail__assemble__fold {
  font-size: 1.83rem;
  margin-top: 60px;
}
.box-detail__assemble-sequence img {
  /* max-width: 100%; */
  margin-left: -20px;
  width: 100vw;
  max-height: 100vh;
  object-fit: contain;
}
.box-detail__assemble-sequence .sequence_title {
  font-size: 1.83rem;
  margin: 60px 0;
}
.primary-title {
  margin-top: 0;
  font-size: 1.83rem;
}
.box-detail__complete img {
  max-width: 100%;
}
.box-detail__complete .route-button {
  margin-top: 60px;
  margin-bottom: 60px;
  font-size: 10px;
}
.completeImage {
  border-radius: 30px;
  width: 100%;
}


@media (min-width: 720px) {
 
  .box-detail {
    max-width: 1200px;
    padding-left: 100px;

    padding-right: 100px;
  }
  .box-detail > * {
    padding-left: 0;
    padding-right: 0;
  }
  .slider-image {
    /* overflow-x: auto;
    width: 100vw; */

    margin-left: -100px;
    padding: 0 100px;
    /* box-sizing: border-box; */
  }
  .slider-image img {
    width: calc(200% + 200px);
  }
  .box-detail__instruction > div > * {
    font-size: 1.57rem;
  }
 .box-detail__prepare{
    margin-top:55px;
  }
  .box-detail__prepare .title {
    font-size: 2.28rem;
  }
  .box-detail__prepare .img {
    text-align: center;
  }
  .box-detail__assemble-sequence .sequence-image {
    text-align: center;
  }
  .box-detail__assemble-sequence .sequence-image img {
    text-align: center;
    width: 100%;
    max-width: 100%;
  }
  .order-number {
    margin-top: 90px;
    font-size: 3.28rem;
  }
  .box-detail__design .title {
    /* margin-bottom: 1.28rem; */
    font-size: 2.28rem;
  }
  /* .design-image-list .design-image-item .design-image-item__title {
    padding-left: 30px;
  } */
  .design-image-list
    .design-image-item
    .design-image-item__title
    .design-image-number {
    width: 27px;
  }
  .box-detail__design .description {
    margin-bottom: 1.28rem;
    font-size: 24px;
  }

  .design-warning {
    margin-top: 30px;
  }
  .design-warning li {
    font-size: 1.714rem;
  }
  .design-warning3 {
    font-size: 1.714rem;
    margin-top: 75px;
  }
  .design-dot-image {
    margin-top: 35px;
  }
  .design-dot-image img {
    /* margin-top: 35px; */
    width: 410px;
  }
  .design-image-list {
    display: flex;
    flex-wrap: wrap;
    /* grid-template-rows: auto; */
    /* grid-template-columns: repeat(2, 1fr); */
    /* grid-row-gap: 30px;
    grid-column-gap: 30px; */
    justify-content: space-between;
    margin-top: 0;
    /* margin-left: -60px;
    margin-right: -60px; */
    /* width: 880px; */
    /* width: 100%; */
    max-width: 1000px;
    width: 100%;
  }
  .design-image-list .design-image-item {
    margin-top: 0;
    width: 100%;
    flex-basis: calc(50% - 15px);
    margin-right: 0px;
    margin-left: 0px;
    box-sizing: border-box;
  }
  .design-image-list .design-image-item img {
    /* margin-top: 0; */
    width: 100%;
  }
  .design-image-list .design-image-item .design-image-item__title {
    margin-top: 60px;
    font-size: 2.28rem;
    /* width: 100%; */
  }
  .box-detail__assemble-wrapper {
    margin-top: 90px;
    display: flex;
    flex-wrap: wrap;
  }
  .box-detail__assemble-wrapper .order-number {
    margin-top: 0;
  }
  .box-detail__assemble-title .box-detail__assemble__primary {
    font-size: 2.28rem;
    margin-bottom: 16px;
    margin-top: 8px;
  }
  .box-detail__assemble-title .box-detail__assemble__secondary {
    font-size: 24px;
    /* max-width: 60%; */
    max-width: 500px;
  }
  .box-detail__assemble__fold-secondary {
    font-size: 24px;
    /* max-width: 60%; */
    max-width: 500px;
  }

  .box-detail__assemble,
  .box-detail__assemble-sequence {
    width: 48%;
    margin-right: 0;
    max-width: 482px;
  }
  .box-detail__assemble:nth-child(odd) {
    width: 45%;
    margin-right: 30px;
  }

  .box-detail__assemble-wrapper > div:nth-child(2n) {
    margin-right: auto;
  }
  .box-detail__assemble-wrapper > div:not(.cutout),
  .box-detail__assemble-wrapper > div:not(.fold) {
    margin-top: 90px;
  }

  .box-detail__assemble-sequence.fold-true {
    margin-top: 90px;
    width: 50%;
  }

  .box-detail__assemble img {
    max-width: 450px;
    width: 100%;
  }
  .box-detail__assemble__cut-out-parts,
  .box-detail__assemble-sequence .sequence_title {
    margin-top: 0;
    margin-bottom: 88px;
    font-size: 2.28rem;
  }
  .margin-0 {
    margin-bottom: 0 !important;
  }

  .box-detail__assemble__fold {
    font-size: 2.28rem;
    margin-top: 90px;
  }
  .box-detail__assemble-fold {
    max-width: 450px;
    width: 100%;
  }
  .box-detail__complete .primary-title {
    font-size: 2.28rem;
  }

  .box-detail__complete .route-button {
    max-width: 890px;
    width: 100%;
    border-radius: 46px;
    padding-top: 30px;
    padding-bottom: 30px;
    font-size: 1.72rem;
    line-height: 0.87;
    font-weight: 500;
  }
  .route-button.left::before {
    content: " ";
    border-top: 2px solid #f5f5f5;
    border-left: 2px solid #f5f5f5;
    width: 10px;
    height: 10px;
    position: absolute;
    left: 34px;
    top: 50%;
    transform: translateY(-50%) rotate(-45deg);
  }
  .instructions{
  padding-bottom:55px;
}
  .cautionButton{
 font-size: 1.57rem;
}
}

.pin {
  transform: translate3D(0, 0, 0);
  margin-bottom: 60px;
}

@media (min-width: 1024px) {

  .box-detail__design .indicator-list {
    display: none;
  }
  .box-detail__prepare{
    margin-top:55px;
  }
  .slider-image {
    width: 100%;
    padding: 0;
    margin: 0;
  }
  .slider-image img {
    width: 100%;
  }

  .pin {
    margin-bottom: 90px;
  }
  .just-center {
    display: flex;
    justify-content: center;
    width: 1030px;
    margin-left: -15px;
  }

  .design-image-item__title_text.margin-left {
    margin-left: 3.5px;
  }
  .instructions{
  padding-bottom:55px;
}
.cautionButton{
 margin-top:15px;
 font-size: 1.57rem;

}

}
</style>
